export default __webpack_public_path__ + "static/media/zillow.1a841f41.png";